import {
  ContactInfo,
  ContactPreference,
  DoctorInfoReq,
  ExtraArgs,
  NumberType,
  Role,
  UserData,
} from "./Sms.model";
import { apiService } from "../../../services/apiService";
import { apiServiceConstants } from "../../../constants/apiService.constants";
import { utilService } from "../../../services/utilService";
import { DoctorInfoResp } from "./Sms.model";
import { StorageService } from "../../../services";
import { CONSTANTS } from "../../../constants";

const getDoctorInformation = async (
  params: DoctorInfoReq
): Promise<DoctorInfoResp> => {
  const respApiResult = await apiService
    .apiCall(
      `user/v2/${params.guid}/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const submitScheduleListResp = res as DoctorInfoResp;
      var DoctorInformationResponse: any;
      if (submitScheduleListResp.result) {
        DoctorInformationResponse = setDoctorInfoModel(
          submitScheduleListResp.result?.[0]
        );
      }
      const result: DoctorInfoResp = {
        isSuccess: true,
        result: DoctorInformationResponse,
        status: submitScheduleListResp.status,
        message: submitScheduleListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: DoctorInfoResp = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getAssignedContactInformation = async (
  params: DoctorInfoReq
): Promise<DoctorInfoResp> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/get-nurse-assign-number/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const submitScheduleListResp = res as DoctorInfoResp;
      var DoctorInformationResponse: any;
      if (submitScheduleListResp.result) {
        DoctorInformationResponse = setDoctorInfoModel(
          submitScheduleListResp.result?.[0]
        );
      }
      const result: DoctorInfoResp = {
        isSuccess: true,
        result: DoctorInformationResponse,
        status: submitScheduleListResp.status,
        message: submitScheduleListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: DoctorInfoResp = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setDoctorInfoModel = (payload: any) => {
  if (payload == null) {
    return {};
  } else {
    var extraArgsDataObject = {
      extraArgs: mapExtraArgs(payload.extra_args),
      userData: mapUserData(payload.user_data),
    };
    return extraArgsDataObject;
  }
};

const mapUserData = (userData: UserData) => {
  StorageService.setStorageItem(
        localStorage,
        {
          n2nPermission: userData.n2n_activation,
        },
        true
      );
  if (userData == null) {
    return {};
  } else {
    var userDataObject = {
      image: userData.image,
      id: userData.id,
      assignNumber: userData.assign_number,
      userName: userData.username,
      email: userData.email,
      firstName: userData.first_name,
      groups: userData.groups,
      lastName: userData.last_name,
      displayName: userData.display_name,
      mobileNumber: userData.mobile_number,
      alternateNumber: userData.alternate_number,
      pager: userData.pager,
      roles: mapRolesDetails(userData.roles),
      profilePic: userData.profile_pic,
      // profilePic: mapProfilePic(userData.profile_pic) ,
      contactPreference: mapContactPreference(userData.contact_preference),
      guid: userData.guid,
      color: userData.color,
      unavailableWhenNotOnCall: userData.unavailable_when_not_oncall,
      countryCode: userData.country_code,
      contactInfo: mapContactInfo(userData.contact_info),
      primaryCanSendSms: userData.primary_can_send_sms,
      secondaryCanSendSms: userData.secondary_can_send_sms,
      roleBasedPermission: mapRoleBasedPermissions(
        userData.role_based_permission ? userData.role_based_permission : null
      ),
      specialty_names:userData?.specialty_names ?? "",
      n2nActivation:userData?.n2n_activation,
      n2nUserListing:userData?.n2n_user_listing,
      sipUsername:userData?.sip_username
    };
    return userDataObject;
  }
};

//TO DO
const mapImageData = (profilePic: string) => {
  {
    if (profilePic !== null) {
      // if(! profilePic.includes("://thecallcentral.com")){
      // profilePic = `https://thecallcentral.com/${profilePic}`;
      // }
      // if(! profilePic.includes("://thecallcentral.com") && ! profilePic.includes("assets/images/defaultProfilePic.png")){
      profilePic = utilService.getBaseUrl() + profilePic;
      // }
    } else {
      profilePic = "assets/images/defaultProfilePic.png";
    }
    return profilePic;
  }
};

const mapRolesDetails = (rolesData: Array<Role>) => {
  var rolesDataObject: any;
  if (rolesData == null) {
    return [];
  } else {
    let roleDataArray: Array<Role> = [];
    rolesData.map((items: any) => {
      rolesDataObject = {
        name: items.name,
        id: items.id,
      };
      roleDataArray.push(rolesDataObject);
    });
    return roleDataArray;
  }
};

const mapContactPreference = (
  contactPreferenceData: Array<ContactPreference>
) => {
  var conatctPreferenceDataObject: any;
  if (contactPreferenceData == null) {
    return [];
  } else {
    let roleDataArray: Array<ContactPreference> = [];
    contactPreferenceData.map((items: any) => {
      conatctPreferenceDataObject = {
        email: items.email,
        mobileNumber: items.mobile_number,
        pager: items.pager,
        alternateNumber: items.alternate_number,
      };
      roleDataArray.push(conatctPreferenceDataObject);
    });
    return roleDataArray;
  }
};

const mapContactInfo = (contactInfoData: Array<ContactInfo>) => {
  var contactInfoDataObject: any;
  if (contactInfoData == null) {
    return [];
  } else {
    let contactInfoDataArray: Array<ContactInfo> = [];
    contactInfoData.map((items: any) => {
      contactInfoDataObject = {
        id: items.id,
        number: items.number,
        numberStatus: items.number_status,
        canSendSms: items.can_send_sms,
        canCall: items.can_call,
        numberType: items.number_type,
      };
      contactInfoDataArray.push(contactInfoDataObject);
    });
    return contactInfoDataArray;
  }
};

const mapRoleBasedPermissions = (roleBasedPermissionData: any) => {
  if (roleBasedPermissionData === null) {
    return {};
  } else {
    var mapRoleBasedPermissionDataObject = {
      myScheduleCard: roleBasedPermissionData.my_schedule_card,
      statusBoard: roleBasedPermissionData.status_board,
      coverageTab: roleBasedPermissionData.coverage_tab,
      onBehalf: roleBasedPermissionData.on_behalf,
      onCallLookUp: roleBasedPermissionData.on_call_look_up,
      editCareTeam: roleBasedPermissionData.edit_care_team,
      editSupportStaff: roleBasedPermissionData.edit_support_staff,
      addCareTeam: roleBasedPermissionData.add_care_team,
      addSupportStaff: roleBasedPermissionData.add_support_staff,
      notiifyCareTeam: roleBasedPermissionData.notify_care_team,
      nurseManagement: roleBasedPermissionData.nurse_management,
      newCustomColumn: roleBasedPermissionData.new_custom_column,
      addAdditionalColumn: roleBasedPermissionData.add_additional_column,
      admitPatient: roleBasedPermissionData.admit_patient,
      myPatients: roleBasedPermissionData.my_patients,
      messagePermission: roleBasedPermissionData.message_permission,
      unassignShift: roleBasedPermissionData.unassign_shift,
      mediaShare: roleBasedPermissionData.media_share,
      aiChatBot:roleBasedPermissionData.ai_chatbot,
      isOnUser:roleBasedPermissionData?.is_on ?? false,
      isDnUser:roleBasedPermissionData?.is_dn ?? false,
    };
    return mapRoleBasedPermissionDataObject;
  }
};

const mapExtraArgs = (extraArgsData: ExtraArgs) => {
  if (extraArgsData == null) {
    return {};
  } else {
    var extraArgsDataObject = {
      number_types: mapNumberTypes(extraArgsData.number_types),
    };
    return extraArgsDataObject;
  }
};

const mapNumberTypes = (numberTypesData: Array<NumberType>) => {
  var numberTypeObject: any;
  if (numberTypesData == null) {
    return [];
  } else {
    let numberTypesArray: Array<NumberType> = [];
    numberTypesData.map((items: any) => {
      numberTypeObject = {
        value: items.value,
        key: items.key,
      };
      numberTypesArray.push(numberTypeObject);
    });
    return numberTypesArray;
  }
};

const handleErrorResponse = () => {};

export const smsService = {
  getDoctorInformation,
  handleErrorResponse,
  getAssignedContactInformation,
};
